import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const mediaSrc = (p) => (p && p.startsWith("http") ? p : `${BACKEND_URL}/api/files/${p}`);

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("wyd_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
